module.exports = __webpack_public_path__ + "img/product-preview-30.a67cf91.png";